<div class="relative grid grid-cols-1 md:grid-cols-6 gap-4 p-4 min-h-dvh" [ngClass]="containerClass()">
    <div class="col-span-1 md:col-span-5 flex flex-col gap-8">
        <ng-content></ng-content>
    </div>
    <div class="relative hidden md:block col-span-1">
        <div class="sticky top-5 w-full min-h-[100px]">
            <!-- <otw-adsense adClient="ca-pub-7072911416589205" adSlot="8518495096" adFormat="autorelaxed"
                [fullWidthResponsive]="true">></otw-adsense> -->
        </div>
    </div>
</div>